import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initMetaPixel, isMarketingPath, trackPageView } from '../utils/metaPixel';
import { trackGoogleAdsPageView } from '../utils/googleAds';

// Drives the Meta Pixel from React Router. On each route change to a marketing
// page it initializes the pixel on first visit (which fires the first PageView)
// and re-fires PageView on every subsequent in-app navigation — without this an
// SPA only ever counts the initial hard load. Non-marketing routes (/portal,
// /login, noindex utilities) are skipped, so the pixel never loads there.
//
// No-op end to end when REACT_APP_META_PIXEL_ID is unset: initMetaPixel does
// nothing and isMetaPixelReady stays false.
export default function useMetaPixel() {
	const location = useLocation();

	useEffect(() => {
		if (!isMarketingPath(location.pathname)) return;
		initMetaPixel(); // idempotent; loads the lib on the first marketing view
		trackPageView(); // first marketing load AND every subsequent SPA nav
		// Google Ads (added 2026-08-08). No per-view event — gtag's own `config`
		// reports the page — so this only ensures the tag is present early enough
		// to read the ad click's ?gclid into its first-party cookie. Also a clean
		// no-op while REACT_APP_GOOGLE_ADS_ID is unset. The hook name is now a
		// little narrow for what it does; left alone rather than renamed mid-push.
		trackGoogleAdsPageView(location.pathname);
	}, [location.pathname]);
}
